<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Zone Map</h1>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col cols="12" sm="12" md="3">
            <v-select
              :items="regions"
              v-model="region_id"
              label="Region..."
              prepend-inner-icon="map"
              item-text="name"
              item-value="id"
              @change="getZonePins"
              :loading="loading && $vuetify.breakpoint.smAndDown"
              clearable
            ></v-select>
          </v-col>

          <v-col cols="12" md="3" class="justify-center" v-if="isInternalUser">
            <v-select
              :items="listState"
              v-model="selectedState"
              label="Show unzoned pins"
              prepend-inner-icon="fas fa-map-pin"
              @change="getUnzonePins"
              clearable
            ></v-select>
          </v-col>

          <!--          <v-col cols="12" sm="12" md="3" v-if="isInternalUser">-->
          <!--            <v-select-->
          <!--              :items="renderedEmptyZones"-->
          <!--              v-model="emptyZone"-->
          <!--              label="Empty zones..."-->
          <!--              prepend-inner-icon="empty"-->
          <!--              item-text="name"-->
          <!--              item-value="id"-->
          <!--              :loading="loading && $vuetify.breakpoint.smAndDown"-->
          <!--              clearable-->
          <!--            ></v-select>-->
          <!--          </v-col>-->




          <v-col cols="12" md="3" class="justify-center">
            <v-autocomplete
              v-model="selectedLocation"
              :items="postcodeResults"
              :search-input.sync="searchQuery"
              :loading="searchLoading"
              item-text="display_name"
              :return-object="true"
              label="Search suburb, postcode or country"
              placeholder="Type to search..."
              prepend-inner-icon="mdi-magnify"
              clearable
              @change="handleLocationSelect"
              hide-no-data
              hide-selected
              class="location-search"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3" class="justify-center" v-if="isInternalUser">
            <GmapAutocomplete
              @place_changed="handlePlaceChanged"
              class="googleSearchBar"
              placeholder="Search Google Maps"
            ></GmapAutocomplete>
          </v-col>

          <v-col cols="3" md="3" v-if="$vuetify.breakpoint.mdAndUp">
            <v-progress-circular v-if="loading" color="blue-darken-1" indeterminate class="align-center"></v-progress-circular>
          </v-col>
        </v-row>

        <v-card v-if="region_id">
          <v-container class="row justify-space-around ma-0" style="width: 100%">
            <v-col cols="12" md="6" class="pa-2 justify-center" align-self="center">
              <v-row class="justify-center pa-0" align="center">
                <!--                <v-card-text>Selected zones</v-card-text>-->
                <v-chip-group
                  v-model="focusedZone"
                >
                  <v-chip
                    v-for="(zoneName, idx) in selectedZones"
                    :key="'chips'+idx"
                    :value="zoneName"
                    outlined
                    color="primary"
                    close @click:close="unselectZone(zoneName)"
                  >
                    {{ zoneName }}
                  </v-chip>
                  <v-chip
                    v-for="(zoneName, idx) in renderedEmptyZones"
                    :key="'chips'+zoneName+idx"
                    :value="zoneName"
                    outlined
                    color="primary"
                  >
                    {{ zoneName }}
                  </v-chip>
                </v-chip-group>
                <v-chip v-if="selectedZones.length === 0">No selection</v-chip>
              </v-row>
            </v-col>
          </v-container>
        </v-card>
      </v-container>

      <v-container>

        <div style="height: 70vh;">
          <l-map
            ref="map"
            class="LMap"
            :zoom="zoom"
            :minZoom="4"
            :maxZoom="18"
            :center="center"
            @update:zoom="zoomUpdated"
            @update:center="centerUpdated"
            @update:bounds="boundsUpdated"
            :options="{
              zoomControl: true,
              zoomAnimation: true,
              zoomSnap: 0.5
            }"
            @ready="onMapReady"
          >
            <l-tile-layer :url="url"></l-tile-layer>

            <l-control position="topleft">
              <div style="display: flex; flex-direction: column">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      height="26px" width="26px" icon style="background-color: #fff; border-radius: 6px" elevation="6"
                      @click="showCircles=!showCircles"
                      :color="showCircles ? '': 'primary'"
                    >
                      <v-icon small dark>far fa-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Hide Cirles</span>
                </v-tooltip>

                <v-expansion-panels class="mt-2" elevation="6" v-if="editPermission">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      disable-icon-rotate
                      class="pa-1"
                      style="height: 26px; min-height: 0"
                      color="primary"
                      @click="switchMultiSelection"
                    >
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <div>
                            <v-icon :color="multiSelectMode ? 'primary': ''" small v-on="on">far fa-object-ungroup</v-icon>
                          </div>
                        </template>
                        <span>Multi-selection</span>
                      </v-tooltip>
                      <template v-slot:actions>
                        <v-icon color="teal"></v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            height="26px" width="26px" icon style="background-color: #fff; border-radius: 6px" elevation="2"
                            @click="drawPolygon"
                            color="primary"
                          >
                            <v-icon small dark>fas fa-pencil-alt</v-icon>
                          </v-btn>
                        </template>
                        <span>Add selection zone</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            height="26px" width="26px" icon style="background-color: #fff; border-radius: 6px" elevation="2"
                            :disabled="selectedPin.length === 0"
                            @click="clearSelectedPin"
                            color="primary"
                          >
                            <v-icon small dark>fas fa-broom</v-icon>
                          </v-btn>
                        </template>
                        <span>Clear selection</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            height="26px" width="26px" icon style="background-color: #fff; border-radius: 6px" elevation="2"
                            :disabled="!multiSelectMode"
                            @click="deleteAllSelectedPin"
                            color="primary"
                          >
                            <v-icon small dark>fas fa-trash</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete selected pin</span>
                      </v-tooltip>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            height="26px" width="26px" icon style="background-color: #fff; border-radius: 6px" elevation="2"
                            :disabled="!focusedZone"
                            @click="addAllSelectedPin"
                            color="primary"
                          >
                            <v-icon small dark>fa-plus-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Add selected pin to focus zone</span>
                      </v-tooltip>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </l-control>

            <div v-if="centerCircle !== null && showCircles">
              <l-circle
                v-for="(circle, index) in centerCircle"
                :key="'circle' + index"
                :lat-lng="circle.center"
                :radius="circle.radius"
                :visible="circle.show"
              >
                <l-popup>
                  <div>{{'Zone Name : ' + circle.zoneName}}</div>
                  <div>{{'Nb of suburbs: ' + circle.suburbNumber }}</div>
                  <v-col cols="12" align="center">
                    <v-btn
                      @click="selectZone(circle)"
                      x-small color="primary"
                    >
                      Show pins
                    </v-btn>
                  </v-col>
                </l-popup>
              </l-circle>
            </div>

            <div v-for="(zoneName, idx) in selectedZones" :key="'zoneName'+idx">
              <l-marker
                ref="marker"
                v-if="zoneToPin[zoneName] !== null"
                v-for="(zonePin, index) in zoneToPin[zoneName]"
                :key="index"
                :lat-lng="{lat: zonePin.latitude, lng: zonePin.longitude}"
                :icon="getIcon(zonePin)"
                @click="selectPin(zonePin)"
              >
                <l-popup ref="popup">
                  <div class="mb-2" style="color: #3498db; width:100%; text-align: center" v-if="focusedZone===zonePin.zone_name">Focus</div>
                  <div>{{'Zone Name : ' + zonePin.zone_name }}</div>
                  <div>{{'Suburb: ' + zonePin.suburb }}</div>
                  <div>{{'Postcode: ' + zonePin.postcode }}</div>
                  <div>{{'Zone: ' + zonePin.zone_id }}</div>
                  <v-col cols="12" align="center" v-if="!multiSelectMode">
                    <v-btn
                      @click="unselectZone(zonePin.zone_name)"
                      x-small color="primary"
                    >
                      Hide zone pin
                    </v-btn>
                    <v-btn v-if="editPermission"
                           @click="removePin(zonePin)"
                           x-small color="error"
                    >
                      Remove pin
                    </v-btn>
                  </v-col>
                </l-popup>
              </l-marker>
            </div>

            <!--            <v-marker-cluster ref="markerCluster" :options="{disableClusteringAtZoom: 10, chunkedLoading: true, chunkInterval: 1000}">-->
            <!--              <l-marker-->
            <!--                v-if="unzonedPins !== null"-->
            <!--                v-for="(unzonedPin, index1) in unzonedPins"-->
            <!--                :key="'unzoned'+ index1"-->
            <!--                :lat-lng="{lat: unzonedPin.latitude, lng: unzonedPin.longitude}"-->
            <!--                @click=""-->
            <!--                >-->
            <!--                <l-popup>-->
            <!--                  <div>{{'No zone'}}</div>-->
            <!--                  <div>{{'Suburb: ' + unzonedPin.suburb }}</div>-->
            <!--                  <div>{{'Postcode: ' + unzonedPin.postcode }}</div>-->
            <!--                  <v-col cols="12" align="center" v-if="editPermission">-->
            <!--                    <v-btn-->
            <!--                      :disabled="!focusedZone"-->
            <!--                      @click="addToFocusZone(unzonedPin)"-->
            <!--                      x-small color="primary"-->
            <!--                    >-->
            <!--                      {{'Add to ' + focusedZone}}-->
            <!--                    </v-btn>-->
            <!--                  </v-col>-->
            <!--                </l-popup>-->
            <!--              </l-marker>-->
            <!--            </v-marker-cluster>-->


            <v-marker-cluster ref="markerCluster" :options="{disableClusteringAtZoom: 10, chunkedLoading: true, chunkInterval: 1000}">-->
              <l-marker
                v-if="findPin !== null"
                :lat-lng="{lat: findPin.latitude, lng: findPin.longitude}"
                @click=""
              >
                <l-popup>
                  <div>{{'No zone'}}</div>
                  <div>{{'Suburb: ' + findPin.suburb }}</div>
                  <div>{{'Postcode: ' + findPin.postcode }}</div>
                  <v-col cols="12" align="center" v-if="editPermission">
                    <v-btn
                      :disabled="!focusedZone"
                      @click="addToFocusZone(findPin)"
                      x-small color="primary"
                    >
                      {{'Add to ' + focusedZone}}
                    </v-btn>
                  </v-col>
                </l-popup>
              </l-marker>
            </v-marker-cluster>

          </l-map>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import L, {Point} from 'leaflet';
import 'leaflet.markercluster'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet-draw';
import {Icon, latLng, DomEvent} from 'leaflet';
import {LMap, LTileLayer, LMarker, LPopup, LTooltip, LCircle, LControl, LCircleMarker} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import Templates from "../Admin/Templates";
export default {
  name: "ZoneMap",
  components: {
    Templates,
    LMap,
    LTileLayer,
    LMarker,
    LCircleMarker,
    LPopup,
    LTooltip,
    LCircle,
    LControl,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    // PruneCluster,
    Icon
  },
  data() {
    return {
      showMap: true,
      loading: false,
      searchLoading: false,
      searchQuery: null,
      selectedLocation: null,
      postcodeResults: [],
      regions: null,
      region_id: null,
      showUnzoned: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 4,
      defaultZoom: 4,
      focusZoom: 13, // Slightly zoomed out to show more context
      center: [-24.25, 133.4167],
      bounds: null,
      mapOptions: {
        zoomSnap: 0.5,
        zoomAnimation: true
      },
      zonedpins: null,
      unzonedPins: null,
      unzonedMarkers: [],
      centerCircle: null,
      zoneToPin: null,
      selectedZones: [],
      focusedZone: null,
      showCircles: true,
      multiSelectMode: false,
      selectedPin: [],
      selectedUnzonedPin: [],
      emptyZoneToId: {},
      reloadEmptyZone: false,
      selectedState: null,
      listState: [
        {text: "NSW", value: 'NSW'},
        {text: "Victoria", value: 'VIC'},
        {text: "Queensland", value: 'QLD'},
        {text: "South Australia", value: 'SA'},
        {text: "Western Australia", value: 'WA'},
        {text: "Northern Territory", value: 'NT'},
        {text: "Tasmania", value: 'TAS'},
        {text: "CAPITAL", value: 'ACT'},
        {text: "North Island NZ", value: 'North Island'}
      ],
      dict: {},
      usedColors: 0,
      greenIcon: null,
      iconColors: [
        {
          color: '#3FEEE6',
          circleColor: '#32beb8'
        },
        {
          color: '#e27D60',
          circleColor: '#bd6950'
        },
        {
          color: '#e8a87c',
          circleColor: '#a67858'
        },
        {
          color: '#c38d9e',
          circleColor: '#835f69'
        },
        {
          color: '#41b3a3',
          circleColor: '#2d7a6f'
        },
        {
          color: '#ff6600',
          circleColor: '#bf4d00'
        },
        {
          color: '#0c99a2',
          circleColor: '#09656b'
        },
      ],
      iconList: [],
      drawnItems: null,
      // for the marker cluster
      markerCluster: null,
      findPin:null,
      mapInstance: null
    }
  },
  watch: {
    searchQuery(val) {
      if (val && val.length > 2) {
        this.searchPostcodeData(val);
      }
    }
  },
  mounted() {
    this.getRegions();
    
    // Set up map when component is mounted
    this.$nextTick(() => {
      if (this.$refs.map && this.$refs.map.mapObject) {
        this.mapInstance = this.$refs.map.mapObject;
      }
    });

    // problem with webpack
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
    // get the draw
    this.$nextTick(() => {
      const map = this.$refs.map.mapObject;
      const drawnItems = L.featureGroup().addTo(map);
      this.drawnItems = drawnItems;
      const drawControl = new window.L.Control.Draw({
        position: 'topleft',
        draw: {
          polyline: false,
          polygon: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false,
        },
        // edit: {
        //   featureGroup: drawnItems,
        //   poly: {
        //     allowIntersection: false
        //   }
        // },
      });
      // function selectInsidePin(poly){
      //   for (let i=0; i < this.selectedZones.length; i++){
      //     this.zoneToPin[ this.selectedZones[i] ].forEach( pin => {
      //       if (this.isPinInsidePolygon(pin, poly)){
      //         console.log(pin)
      //         pin.selected = true
      //       }
      //     })
      //   }
      // }
      let selectInsidePin = this.selectInsidePin;
      map.addControl(drawControl);
      map.on(L.Draw.Event.CREATED, function (event) {
        var layer = event.layer;
        drawnItems.addLayer(layer);
        console.log(layer.toGeoJSON());
        selectInsidePin(layer.toGeoJSON());
      });
    });
    // get the prune cluster
    this.markerCluster = L.markerClusterGroup({
      disableClusteringAtZoom: 10,
    }).addTo(this.$refs.map.mapObject);
  },
  computed: {
    isInternalUser() {
      return this.$store.getters['auth/isInternalUser'];
    },
    editPermission() {
      return this.$store.getters['auth/hasPermission']('zone_edit');
    },
    renderedEmptyZones(){
      if (this.emptyZones === null || this.emptyZones === undefined) {
        return [];
      } else {
        const emptyZ = this.emptyZones;
        this.emptyZoneToId = {};
        emptyZ.forEach( z => {
          this.emptyZoneToId[z.name] = z.id;
        });
        return emptyZ.map( zone => {return zone.name});
      }
    }
  },
  methods: {
    async searchPostcodeData(query) {
      this.searchLoading = true;
      try {
        const response = await axios.get(`${process.env.API_URL}/zones/autocomplete?s=${encodeURIComponent(query)}`);
        // Normalize results and ensure latitude/longitude numeric fields exist when possible
        const normalized = response.data.map(item => {
          const parts = [];
          if (item.suburb) parts.push(item.suburb);
          if (item.postcode) parts.push(item.postcode);
          if (item.state) parts.push(item.state);
          else if (item.country) parts.push(item.country);

          // attempt to extract coordinates from many possible shapes
          let rawLat = undefined;
          let rawLng = undefined;

          const tryGet = (obj, keys) => {
            for (let k of keys) {
              if (obj && obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
            }
            return undefined;
          };

          rawLat = tryGet(item, ['latitude', 'lat', 'y']);
          rawLng = tryGet(item, ['longitude', 'lng', 'lon', 'long', 'x']);

          // Also check nested common containers
          if ((rawLat === undefined || rawLng === undefined) && item.location) {
            rawLat = rawLat === undefined ? tryGet(item.location, ['latitude', 'lat', 'y']) : rawLat;
            rawLng = rawLng === undefined ? tryGet(item.location, ['longitude', 'lng', 'lon', 'long', 'x']) : rawLng;
          }
          if ((rawLat === undefined || rawLng === undefined) && item.properties) {
            rawLat = rawLat === undefined ? tryGet(item.properties, ['latitude', 'lat', 'y']) : rawLat;
            rawLng = rawLng === undefined ? tryGet(item.properties, ['longitude', 'lng', 'lon', 'long', 'x']) : rawLng;
          }
          if ((rawLat === undefined || rawLng === undefined) && item.attributes) {
            rawLat = rawLat === undefined ? tryGet(item.attributes, ['latitude', 'lat', 'y']) : rawLat;
            rawLng = rawLng === undefined ? tryGet(item.attributes, ['longitude', 'lng', 'lon', 'long', 'x']) : rawLng;
          }

          // geojson style: geometry.coordinates could be [lng, lat]
          if ((rawLat === undefined || rawLng === undefined) && item.geometry && Array.isArray(item.geometry.coordinates)) {
            const c = item.geometry.coordinates;
            if (c.length >= 2) {
              const c0 = parseFloat(c[0]);
              const c1 = parseFloat(c[1]);
              if (!Number.isNaN(c0) && !Number.isNaN(c1)) {
                // assume [lng, lat] if values in ranges
                if (Math.abs(c0) <= 180 && Math.abs(c1) <= 90) {
                  rawLng = rawLng === undefined ? c0 : rawLng;
                  rawLat = rawLat === undefined ? c1 : rawLat;
                } else {
                  rawLat = rawLat === undefined ? c0 : rawLat;
                  rawLng = rawLng === undefined ? c1 : rawLng;
                }
              }
            }
          }

          // coordinates array (maybe [lat, lng] or [lng, lat])
          if ((rawLat === undefined || rawLng === undefined) && Array.isArray(item.coordinates)) {
            const c = item.coordinates;
            if (c.length >= 2) {
              const c0 = parseFloat(c[0]);
              const c1 = parseFloat(c[1]);
              if (!Number.isNaN(c0) && !Number.isNaN(c1)) {
                if (Math.abs(c0) <= 180 && Math.abs(c1) <= 90) {
                  rawLng = rawLng === undefined ? c0 : rawLng;
                  rawLat = rawLat === undefined ? c1 : rawLat;
                } else {
                  rawLat = rawLat === undefined ? c0 : rawLat;
                  rawLng = rawLng === undefined ? c1 : rawLng;
                }
              }
            }
          }

          // centroid style
          if ((rawLat === undefined || rawLng === undefined) && Array.isArray(item.centroid)) {
            const c = item.centroid;
            if (c.length >= 2) {
              const c0 = parseFloat(c[0]);
              const c1 = parseFloat(c[1]);
              if (!Number.isNaN(c0) && !Number.isNaN(c1)) {
                // ambiguous - assume [lng, lat] if first is within lon range
                if (Math.abs(c0) <= 180 && Math.abs(c1) <= 90) {
                  rawLng = rawLng === undefined ? c0 : rawLng;
                  rawLat = rawLat === undefined ? c1 : rawLat;
                } else {
                  rawLat = rawLat === undefined ? c0 : rawLat;
                  rawLng = rawLng === undefined ? c1 : rawLng;
                }
              }
            }
          }

          const latitude = rawLat !== undefined ? parseFloat(String(rawLat)) : null;
          const longitude = rawLng !== undefined ? parseFloat(String(rawLng)) : null;

          return {
            ...item,
            display_name: parts.join(', '),
            latitude: Number.isFinite(latitude) ? latitude : null,
            longitude: Number.isFinite(longitude) ? longitude : null
          };
        });

        // Log a sample of normalized results to help debug why coordinates might be missing
        console.log('postcodeResults normalized sample:', normalized.slice(0, 10));

        if (!normalized.some(r => r.latitude !== null && r.longitude !== null)) {
          console.warn('postcode autocomplete returned no coordinates for results', response.data);
        }

        this.postcodeResults = normalized;
      } catch (error) {
        console.error('Error fetching postcode data:', error);
        this.$store.commit('displaySnackbar', 'Error searching for locations');
      } finally {
        this.searchLoading = false;
      }
    },

    handleLocationSelect(location) {
      if (!location) return;

      // The 'location' object comes from 'postcodeResults',
      // which was already normalized by searchPostcodeData.
      // We just need to use the 'latitude' and 'longitude' properties directly.
      const lat = location.latitude;
      const lng = location.longitude;

      // Check if they are valid numbers.
      // searchPostcodeData sets them to null if they aren't found or are invalid.
      if (lat === null || lng === null || isNaN(lat) || isNaN(lng)) {
        console.warn('No valid coordinates for selected location:', location);
        this.$store.commit('displaySnackbar', 'Selected location has no coordinates to zoom to');

        // Still set findPin for reference, but don't attempt zoom
        this.findPin = {
          suburb: location.suburb || '',
          postcode: location.postcode || '',
          latitude: null,
          longitude: null
        };
        // Clear the selection
        this.selectedLocation = null;
        return;
      }

      // Update the pin data
      this.findPin = {
        suburb: location.suburb || '',
        postcode: location.postcode || '',
        latitude: lat,
        longitude: lng
      };

      // Use the consistent focusMap method
      this.focusMap(lat, lng);

      // Clear the selection after a short delay
      setTimeout(() => {
        this.selectedLocation = null;
      }, 100);
    },

    handlePlaceChanged(place) {
      if (place) {
        const suburb = this.getAddressComponent(place, "locality") || "";
        const postcode = this.getAddressComponent(place, "postal_code") || "";
        const latitude =
          place.geometry && place.geometry.location
            ? place.geometry.location.lat()
            : null;
        const longitude =
          place.geometry && place.geometry.location
            ? place.geometry.location.lng()
            : null;

        this.findPin = {
          suburb,
          postcode,
          latitude,
          longitude,
        };

        if (latitude !== null && longitude !== null) {
          this.focusMap(latitude, longitude);
        }

        console.log("Place Information:", this.findPin);
      } else {
        console.log("Invalid place object");
      }
    },
    getAddressComponent(place, type) {
      if (place.address_components && Array.isArray(place.address_components)) {
        const component = place.address_components.find((comp) =>
          comp.types.includes(type)
        );
        return component ? component.long_name : null;
      }
      return null;
    },
    
    focusMap(lat, lng) {
      console.log('focusMap called:', lat, lng); // Debug log

      // Ensure we have a map instance reference
      if (!this.mapInstance && this.$refs.map) {
        this.mapInstance = this.$refs.map.mapObject;
      }
      const map = this.mapInstance; // Use the stored instance

      if (!map) {
        console.error('Map not available');
        return;
      }
      
      const latitude = parseFloat(lat);
      const longitude = parseFloat(lng);

      if (isNaN(latitude) || isNaN(longitude)) {
        console.error('Invalid coordinates:', lat, lng);
        return;
      }

      // Update both the reactive properties...
      this.center = [latitude, longitude];
      this.zoom = this.focusZoom; // Use the data property

      // ...and the map directly using flyTo for a smooth transition
      try {
        map.flyTo([latitude, longitude], this.focusZoom, {
          animate: true,
          duration: 1
        });
      } catch (e) {
        // Fallback to setView if flyTo fails (e.g., in tests)
        map.setView([latitude, longitude], this.focusZoom);
      }

      // Force redraw after tiny delay (helps in some rendering edge cases)
      setTimeout(() => {
        map.invalidateSize();
      }, 150);
    },

    onMapReady(map) {
      console.log('Map ready event fired'); // Debug log
      this.mapInstance = map;
      
      // Store initial bounds
      this.initialBounds = map.getBounds();
      
      // Force map to recognize its container
      map.invalidateSize();
      
      // Ensure zoom control is present
      if (!map.zoomControl) {
        map.addControl(L.control.zoom());
      }

      // Add event listeners for zoom
      map.on('zoomend', () => {
        console.log('Current zoom level:', map.getZoom());
      });
    },
    // @vuese
    // Gets all the regions.
    getRegions() {
      axios.get(process.env.API_URL + '/regions')
        .then((response) => {
          this.regions = response.data;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
        })
    },
    getZonePins() {
      this.loading = true;
      this.zonedpins = null;
      this.clearSelectedPin();

      axios.get(process.env.API_URL + '/zones/zonedpins?region=' + this.region_id)
        .then((response) => {
          if (response.data !== null) {
            this.zonedpins = response.data;
            this.selectedZones = [];
            this.getListCircles( response.data );
            this.loading = false;
          } else {
            this.zonedpins = null;
            this.$store.commit('displaySnackbar', 'No pin in this region');
            this.loading = false;
          }
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          this.loading = false;
        })
    },
    getUnzonePins() {
      this.loading = true;
      this.unzonedPins = null;
      axios.get(process.env.API_URL + '/zones/unzonedpins?state=' + this.selectedState)
        .then((response) => {
          if (response.data !== null) {
            this.unzonedPins = [];
            response.data.forEach( item => {
              if (item.longitude && item.latitude){
                this.unzonedPins.push(item);
              }
            });
            // console.log(this.$refs);
            this.updateUnzonedPinCluster();
            this.loading = false;
          } else {
            this.unzonedPins = null;
            this.$store.commit('displaySnackbar', 'No unzoned pins in this state');
            this.loading = false;
          }
        })
        .catch((response) => {
          console.log(response);
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          this.loading = false;
        })
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    getIcon(zonePin) {
      if (this.dict[zonePin.zone_id] == undefined) {
        this.dict[zonePin.zone_id] = this.iconColors[this.usedColors];
        this.usedColors += 1;
        if (this.usedColors > 7) this.usedColors = 0;
      }
      const fillColor = zonePin.selected ? this.dict[zonePin.zone_id].circleColor : this.dict[zonePin.zone_id].color;
      const strokeColor = zonePin.selected ? this.dict[zonePin.zone_id].color : this.dict[zonePin.zone_id].circleColor;
      let coloredIcon = L.divIcon({
        className: "my-custom-pin",
        iconAnchor: [10, 34.892337],
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="40" width="20">
<g transform="translate(-814.59595,-274.38623)">
  <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
    <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z"
    style="fill:${fillColor};stroke:${strokeColor};"/>
    <circle r="${zonePin.selected ? '5.0355' : '3.0355'}" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:${strokeColor};"/>
  </g>
</g>
</svg>`
      });
      return coloredIcon;
    },
    getUnzonedIcon(selected=false){
      const fillColor = selected ? '#3b252c' : '#E3E4DB';
      const strokeColor = selected ? '#E3E4DB' : '#3b252c';
      let icon = L.divIcon({
        className: 'icon',
        iconAnchor: [10, 34.892337],
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="40" width="20">
<g transform="translate(-814.59595,-274.38623)">
  <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
    <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z"
    style="fill:${fillColor};stroke:${strokeColor};"/>
    <circle r="${selected ? '5.0355' : '3.0355'}" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:${strokeColor};"/>
  </g>
</g>
</svg>`
      });
      return icon;
    },
    getListCircles( zonePins){
      const zoneToPin = {};
      for (let id in zonePins ){
        const pin = zonePins[id];
        let zoneName = pin['zone_name'];
        if (zoneToPin[zoneName]){
          zoneToPin[zoneName].push(pin);
        } else {
          zoneToPin[zoneName] = [pin];
        }
      }
      const centerCircle = {};
      let zoneNum = 0;
      for (let zoneName in zoneToPin){
        var centerLat = 0;
        var centerLong = 0;
        let i=0;
        let pinIcon = this.iconList[zoneNum];
        zoneNum = (zoneNum + 1) % 7;
        for (var id = 0; id < zoneToPin[zoneName].length; id++ ){
          zoneToPin[zoneName][id]['icon'] = pinIcon;
          const pin = zoneToPin[zoneName][id];
          if (pin['latitude'] && pin['longitude']){
            centerLat += pin['latitude'];
            centerLong += pin['longitude'];
            i++;
          }
        }
        centerCircle[zoneName] = {
          center: latLng(centerLat / i, centerLong / i),
          zoneName: zoneName,
          suburbNumber: zoneToPin[zoneName].length,
          radius: 2000*Math.sqrt(zoneToPin[zoneName].length),
          show: true
        };
      }
      this.zoneToPin = zoneToPin;
      this.centerCircle = centerCircle;
    },
    selectZone(circle){
      this.selectedZones.push(circle.zoneName);
      circle.show = false;
    },
    unselectZone(zoneName){
      this.selectedZones = this.selectedZones.filter(nameZone => nameZone !== zoneName );
      this.centerCircle[ zoneName ].show = true;
    },
    addToFocusZone(marker){
      const unzonedPin = marker.pin;
      let zoneId = null;
      let reloadCircle = false;
      if (this.zoneToPin[ this.focusedZone ] && this.zoneToPin[ this.focusedZone ][0]){
        console.log(this.zoneToPin[ this.focusedZone ]);
        zoneId = this.zoneToPin[ this.focusedZone ][0].zone_id;
      }else {
        this.zoneToPin[this.focusedZone] = [];
        zoneId = this.emptyZoneToId[ this.focusedZone ];
        reloadCircle = true;
      }
      axios.post(process.env.API_URL + '/zones/' + zoneId + '/pin', {
        suburb: unzonedPin.suburb,
        postcode: unzonedPin.postcode
      })
        .then((response) => {
          unzonedPin.zone_name = this.focusedZone;
          unzonedPin.zone_id = zoneId;
          this.zoneToPin[ this.focusedZone ].push(unzonedPin);
          this.unzonedPins = this.unzonedPins.filter( pin => pin.suburb !== unzonedPin.suburb || pin.postcode !== unzonedPin.postcode);
          marker.setIcon(this.getUnzonedIcon(false));
          this.selectedUnzonedPin = this.selectedUnzonedPin.filter(m => m.pin.suburb != unzonedPin.suburb);
          this.markerCluster.removeLayer(marker);
          if (reloadCircle){
            this.getZonePins();
            this.reloadEmptyZone = !this.reloadEmptyZone;
          }
        })
        .catch((error) => {
          if(error.response){
            this.$store.commit('displaySnackbar', 'ERROR ' + error.response.data.error);
            this.loading = false
          } else if (error.request){
            this.$store.commit('displaySnackbar', 'ERROR ' + error.request);
          } else {
            this.$store.commit('displaySnackbar', 'ERROR ' + error.response.error);
            console.log(error);
            this.loading = false
          }
        })
    },
    removePin(zonePin){
      axios.delete(process.env.API_URL + '/zones/' + zonePin.zone_id + '/pin',
        {data: {suburb: zonePin.suburb, postcode: zonePin.postcode}})
        .then((response) => {
          if (this.unzonedPins){
            this.unzonedPins.push(zonePin);
            this.addMarkerToUnzone(zonePin);
          }
          this.zoneToPin[ zonePin.zone_name ] = this.zoneToPin[ zonePin.zone_name ].filter( pin => pin.suburb !== zonePin.suburb || pin.postcode !== zonePin.postcode);
        })
        .catch((response) => {
          console.log(response);
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          this.loading = false;
        })
    },
    switchMultiSelection(){
      this.multiSelectMode = !this.multiSelectMode;
      if (this.multiSelectMode){
        console.log('just activated');
      } else{
        console.log('just deactivated');
        this.clearSelectedPin();
      }
    },
    deleteAllSelectedPin(){
      this.selectedPin.forEach(zonePin => {
        this.removePin(zonePin);
      });

      this.clearSelectedPin();
    },
    addAllSelectedPin(){
      this.selectedUnzonedPin.forEach(marker => {
        this.addToFocusZone(marker);
      });
      this.clearSelectedPin();
    },
    clearSelectedPin(){
      //clear zone pin
      this.selectedPin = [];
      for (let i=0; i < this.selectedZones.length; i++){
        this.zoneToPin[ this.selectedZones[i] ].forEach( pin => {pin.selected = false})
      }
      //clear unzoned pin
      this.selectedUnzonedPin.forEach( marker => {
        marker.setIcon(this.getUnzonedIcon(false));
      });
      this.selectedUnzonedPin = [];
      //clear ploygon
      const map = this.$refs.map.mapObject;
      // var editToolbar = new L['EditToolbar'].Delete(map, {featureGroup: this.drawnItems});
      // editToolbar.removeAllLayers();
      const layers = this.drawnItems._layers;
      const layer_ids = Object.keys(layers);
      layer_ids.forEach(id => {
        this.drawnItems.removeLayer(layers[id]);
      });
      map.setZoom();
    },
    selectPin(zonePin){
      if (this.multiSelectMode){
        if (!zonePin.selected){
          zonePin.selected = true;
          this.$refs.map.setZoom();
          this.selectedPin.push(zonePin);
        } else {
          zonePin.selected = false;
          this.$refs.map.setZoom();
          this.selectedPin = this.selectedPin.filter(zp => zp.suburb != zonePin.suburb);
        }
      }
    },
    selectUnzonedPin(event){
      const marker = event.sourceTarget
      if (this.multiSelectMode){
        const isSelected = (this.selectedUnzonedPin.filter(m => m.pin.suburb === marker.pin.suburb).length > 0);
        if (!isSelected){
          event.sourceTarget.setIcon(this.getUnzonedIcon(true));
          this.selectedUnzonedPin.push(marker);
        } else {
          event.sourceTarget.setIcon(this.getUnzonedIcon(false));
          this.selectedUnzonedPin = this.selectedUnzonedPin.filter(m => m.pin.suburb != marker.pin.suburb);
        }
      }
    },
    // for the drawings
    drawPolygon(){
      const map = this.$refs.map.mapObject;
      var drawControl = new L.Draw.Polygon(map);
      drawControl.enable();
    },
    isPinInsidePolygon(zonePin, poly) {
      var polyPoints = poly.geometry.coordinates[0];
      var x = zonePin.latitude, y = zonePin.longitude;
      var inside = false;
      for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
        var xi = polyPoints[i][1], yi = polyPoints[i][0];
        var xj = polyPoints[j][1], yj = polyPoints[j][0];
        var intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }
      return inside;
    },
    selectInsidePin(poly) {
      for (let i=0; i < this.selectedZones.length; i++){
        console.log(this.zoneToPin[ this.selectedZones[i] ])
        this.zoneToPin[ this.selectedZones[i] ].forEach( pin => {
          if (this.isPinInsidePolygon(pin, poly)){
            if (!pin.selected){
              pin.selected = true;
              this.selectedPin.push(pin);
            }
          }
        })
      }
      this.unzonedMarkers.forEach( marker => {
        const pin = marker.pin;
        if (this.isPinInsidePolygon(pin, poly)){
          const isSelected = (this.selectedUnzonedPin.filter(m => m.pin.suburb === marker.pin.suburb).length > 0);
          if (!isSelected){
            marker.setIcon(this.getUnzonedIcon(true));
            this.selectedUnzonedPin.push(marker);
          }
        }
      });
      this.$refs.map.setZoom();
    },
    // for the marker cluster
    updateUnzonedPinCluster(){
      this.markerCluster.clearLayers();
      this.unzonedMarkers = [];
      console.log(this.markerCluster);
      if (this.unzonedPins){
        this.unzonedPins.forEach( pin => {
          this.addMarkerToUnzone(pin)
        });
        console.log(this.markerCluster);
      }
    },
    addMarkerToUnzone(pin){
      //the icon
      let icon = this.getUnzonedIcon(false);
      //the popup
      let popupContent =
        `<div>No zone</div>
                <div>${'Suburb: ' + pin.suburb }</div>
                <div>${'Postcode: ' + pin.postcode }</div>
              `
      let popup = L.popup({offset: new Point(0,-20)}).setContent(popupContent);
      let marker = L.marker([pin.latitude, pin.longitude], {icon: icon});
      marker.pin = pin;
      marker.on('click', this.selectUnzonedPin);
      //bind popup
      marker.bindPopup(popup);
      this.markerCluster.addLayer(marker);
      this.unzonedMarkers.push(marker);
    }
  },
  asyncComputed: {
    async emptyZones() {
      if (this.reloadEmptyZone || !this.reloadEmptyZone){
        if (!this.region_id) return [];
        return await axios.get(process.env.API_URL + '/zones?show_all=true&&locations==true')
          .then((response) => {
            return response.data.filter(zone => {
              return (zone.region_id === this.region_id && zone.locations.length === 0)
            });
          })
          .catch((response) => {
            return [];
          })
      }
    },
  }
}
</script>

<style src="../../../../node_modules/leaflet/dist/leaflet.css"></style>
<style src="../../../../node_modules/leaflet.markercluster/dist/MarkerCluster.css"></style>
<style src="../../../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css"></style>

<style scoped>
div.btn__content {
  padding: 0;
}
div.card__actions .btn {
  min-width: 0;
}
.v-expansion-panel-content__wrap{
  padding: 0;
}
.LMap {
  z-index: 1;
  width: 100%;
}
.my-custom-pin {
  background-color: transparent;
}

.googleSearchBar {
  margin-top: 20px;
  margin-left: 60px;
  width: 500px;
}

.location-search {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ZoneMap.vue